import CustomerChangeTypeHtml from '../customers/templates/customer.change-type.html';

export function ManageDataCtrl (
  $rootScope,
  $scope,
  $translate,
  $uibModal,
  companyApi,
  confirm,
  messages,
  workshopAPI
) {

  $scope.Company = companyApi;
  $scope.Company.setCompany($scope.company);

  $scope.clearCompany = function () {
    confirm.hard(sprintf('Continuing will erase ALL data for <strong>%1$s</strong>. To confirm this action, please type in the code below.', $scope.company.company_name))
      .then(function () {
        confirm.generic(sprintf('Are you sure you want to erase ALL data for <strong>%1$s</strong>? This action cannot be undone', $scope.company.company_name))
          .then(function () {
            workshopAPI.get('/workshop_admin/destroy_company_data', $scope.company.id)
            .then(function (data) {
              messages.show($translate.instant('JS_SPACE.MESSAGES.DATA_ERASED'), 'success');
            }, function (err) {
              messages.error(err);
            });
          });
    });
  };

  $scope.clearProduct = function () {
    confirm.hard(sprintf('Continuing will erase ALL TRANSACTIONS and PRODUCT data (including Bundles) for <strong>%1$s</strong>. To confirm this action, please type in the code below.', $scope.company.company_name))
      .then(function () {
        confirm.generic(sprintf('Are you sure you want to erase ALL PRODUCT and TRANSACTIONAL data for <strong>%1$s</strong>? This action cannot be undone', $scope.company.company_name))
          .then(function () {
            workshopAPI.get('/workshop_admin/destroy_company_data_product', $scope.company.id)
            .then(function (data) {
              messages.show($translate.instant('JS_SPACE.MESSAGES.DATA_ERASED'), 'success');
            }, function (err) {
              messages.error(err);
            });
          });
    });
  };

  $scope.clearVehicle = function () {
    confirm.hard(sprintf('Continuing will erase ALL TRANSACTIONS and VEHICLE data for <strong>%1$s</strong>. To confirm this action, please type in the code below.', $scope.company.company_name))
      .then(function () {
        confirm.generic(sprintf('Are you sure you want to erase ALL VEHICLE and TRANSACTIONAL data for <strong>%1$s</strong>? This action cannot be undone', $scope.company.company_name))
          .then(function () {
            workshopAPI.get('/workshop_admin/destroy_company_data_vehicle', $scope.company.id)
            .then(function (data) {
              messages.show($translate.instant('JS_SPACE.MESSAGES.DATA_ERASED'), 'success');
            }, function (err) {
              messages.error(err);
            });
          });
    });
  };

  $scope.clearCustomer = function () {
    confirm.hard(sprintf('Continuing will erase ALL TRANSACTIONS and CUSTOMER data for <strong>%1$s</strong>. To confirm this action, please type in the code below.', $scope.company.company_name))
      .then(function () {
        confirm.generic(sprintf('Are you sure you want to erase ALL CUSTOMER AND TRANSACTIONAL data for <strong>%1$s</strong>? This action cannot be undone', $scope.company.company_name))
          .then(function () {
            workshopAPI.get('/workshop_admin/destroy_company_data_customer', $scope.company.id)
            .then(function (data) {
              messages.show($translate.instant('JS_SPACE.MESSAGES.DATA_ERASED'), 'success');
            }, function (err) {
              messages.error(err);
            });
          });
    });
  };

  $scope.clearVendor = function () {
    confirm.hard(sprintf('Continuing will erase ALL TRANSACTIONS and VENDOR data for <strong>%1$s</strong>. To confirm this action, please type in the code below.', $scope.company.company_name))
      .then(function () {
        confirm.generic(sprintf('Are you sure you want to erase ALL VENDOR and TRANSACTIONAL data for <strong>%1$s</strong>? This action cannot be undone', $scope.company.company_name))
          .then(function () {
            workshopAPI.get('/workshop_admin/destroy_company_data_vendor', $scope.company.id)
            .then(function (data) {
              messages.show($translate.instant('JS_SPACE.MESSAGES.DATA_ERASED'), 'success');
            }, function (err) {
              messages.error(err);
            });
          });
    });
  };

  $scope.clearMechanic = function () {
    confirm.hard($translate.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.CLEAR_EMPLOYEES_HARD_CONFIRMATION', {
      employeeTitle: $rootScope.Company.labels.employeeTitle.toUpperCase(),
      name         : $scope.company.company_name
    }))
    .then(() => confirm.generic($translate.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.CLEAR_EMPLOYEES_CONFIRMATION', {
      employeeTitle: $rootScope.Company.labels.employeeTitle.toUpperCase(),
      name         : $scope.company.company_name
    })))
    .then(() => workshopAPI.get('/workshop_admin/destroy_company_data_mechanic', $scope.company.id))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.DATA_ERASED'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.clearHistory = function () {
    confirm.hard(sprintf('Continuing will erase VEHICLE HISTORY HEADER data for <strong>%1$s</strong>. To confirm this action, please type in the code below.', $scope.company.company_name))
      .then(function () {
        confirm.generic(sprintf('Are you sure you want to erase ALL VEHICLE HISTORY HEADERS for <strong>%1$s</strong>? This action cannot be undone', $scope.company.company_name))
          .then(function () {
            workshopAPI.get('/workshop_admin/destroy_company_data_history', $scope.company.id)
            .then(function (data) {
              messages.show($translate.instant('JS_SPACE.MESSAGES.DATA_ERASED'), 'success');
            }, function (err) {
              messages.error(err);
            });
          });
    });
  };

  $scope.clearHistoryItem = function () {
    confirm.hard(sprintf('Continuing will erase VEHICLE HISTORY ITEM data for <strong>%1$s</strong>. To confirm this action, please type in the code below.', $scope.company.company_name))
      .then(function () {
        confirm.generic(sprintf('Are you sure you want to erase ALL VEHICLE HISTORY ITEMS for <strong>%1$s</strong>? This action cannot be undone', $scope.company.company_name))
          .then(function () {
            workshopAPI.get('/workshop_admin/destroy_company_data_history_items', $scope.company.id)
            .then(function (data) {
              messages.show($translate.instant('JS_SPACE.MESSAGES.DATA_ERASED'), 'success');
            }, function (err) {
              messages.error(err);
            });
          });
    });
  };

  $scope.clearDemo = function () {
    confirm.hard(sprintf('Continuing will erase ALL TRANSACTIONAL data for <strong>%1$s</strong>. To confirm this action, please type in the code below.', $scope.company.company_name))
      .then(function () {
        confirm.generic(sprintf('Are you sure you want to erase ALL TRANSACTIONAL data for <strong>%1$s</strong>? This action cannot be undone', $scope.company.company_name))
          .then(function () {
            workshopAPI.get('/workshop_admin/destroy_demo_data', $scope.company.id)
            .then(function (data) {
              messages.show($translate.instant('JS_SPACE.MESSAGES.DATA_ERASED'), 'success');
            }, function (err) {
              messages.error(err);
            });
          });
    });

  };

  $scope.changeCustomerType = function () {
    var modalInstance = $uibModal.open({
      templateUrl: CustomerChangeTypeHtml,
      windowClass: 'flip-container',
      resolve: {
        company: function () {
          return $scope.company;
        }
      },
      controller: ['$scope', '$uibModalInstance', '$translate', 'company', function ($scope, $uibModalInstance, $translate, company) {
        $scope.accountType;
        $scope.code = parseInt(Math.random()*10000);
        $scope.typedCode = '';
        $scope.company = company;

        $scope.cancel = $uibModalInstance.dismiss;

        $scope.setAccountType = function (type) {
          $scope.accountType = type;
          $('.modal-content').addClass('flip');
        };

        $scope.back = function () {
          $('.modal-content').removeClass('flip');
        };

        $scope.confirm = function (form) {
          if ( $scope.code.toString() === $scope.typedCode.toString() ) {
            $uibModalInstance.close($scope.accountType);
          }
          else {
            messages.show($translate.instant('JS_SPACE.MESSAGES.CODE_DOES_NOT_MATCH'), 'error');
          }
        };
      }]
    });

    modalInstance.result.then(function (accountType) {
      workshopAPI.get('workshop_admin/change_cash_or_account', [$scope.company.id, accountType])
        .then(function () {

          messages.show($translate.instant('JS_SPACE.MESSAGES.CUSTOMERS_ALL_CHANGED_TO', {name:((accountType == 'C') ? 'Cash' : 'Account')}) , 'success');
        }, function (err) {
          messages.error(err);
        });
    });

  };

  $scope.syncMultiBranchData = function () {
    confirm.generic($translate.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.CONFIRM_SYNC_BETWEEN_BRANCHES'))
    .then(() => workshopAPI.get('workshop_admin/create_or_link_all_records_for_dealer_and_branches', $scope.company.id))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SYNC_SUCCESSFUL'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  // need to reset company to session company
  $scope.$on('$destroy', () => companyApi.setCompany());
}